import React from 'react'
import { useFormContext } from 'react-hook-form'
import { formMessage } from './Message'

function Radio({value, id, name, checked}) {
    const { register } = useFormContext()
    return (
        <div className="group !mb-6">
            <input
                checked={checked}
                {...register(name, { required: formMessage.required })}
                id={id}
                className="sr-only"
                value={value}
                type="radio"
            />
            <label
                className="relative flex w-fit cursor-pointer items-center justify-center pl-11"
                htmlFor={id}
            >
                <span className="pt-2 text-xl font-grotesk-light leading-6">{value}</span>
                <span className="group absolute left-0 top-2 aspect-square w-6 translate-x-1 rounded-full bg-transparent outline outline-[3px] outline-offset-4 outline-vivid_raspberry group-has-[input:checked]:bg-vivid_raspberry"></span>
            </label>
        </div>
    )
}

export default Radio